import qs from "qs";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { FormGroup, Modal, ModalBody } from "reactstrap";
import { Col, Icon } from "../component/Component";
import axiosInstance from "../utils/axios";

export default function UpdateDetails() {
  let { id } = useParams();

  const [campId, setCampId] = useState("");
  const [campType, setCampType] = useState("");
  const [campTitle, setCampTitle] = useState("");

  const [campAccount, setCampAccount] = useState("");
  const [campCustomer, setCampCustomer] = useState("");
  const [walletId, setWalletId] = useState("");

  const [modal, setModal] = useState({
    add: true,
  });

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        const payload = new URLSearchParams();
        payload.append("campaign_reference", id);

        const campaignRes = await axiosInstance.post(
          "full_campaigns",
          payload,
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        );

        const result = Array.isArray(campaignRes.data?.result)
          ? campaignRes.data.result
          : [];

        if (result.length === 0) {
          console.warn("No campaign found for this ID");
          return;
        }

        const campaign = result[0];

        setCampId(campaign.CampaignID);
        setCampType(campaign.Campaign_Type);
        setCampTitle(campaign.title);
      } catch (err) {
        console.error("Failed to load campaign or categories", err);
      }
    };

    fetchData();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post(
        "create_update_campaign_account_details",
        qs.stringify({
          account_no: campAccount,
          customer_id: walletId,
          campaign_reference: campId,
          customer_name: campCustomer,
        })
      );

      if (response.data["status_code"] === "0") {
        toast.success(response.data.message);
        // window.location.href = "/campaign";
        setModal({ add: false });
      } else {
        console.log(toast.error(response.data.message));
      }
    } catch (e) {
      toast.error(e.response);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modal.add}
        toggle={() => setModal({ add: true })}
        className="modal-dialog-centered 80vh"
        size="lg"
      >
        <ModalBody>
          <Link to="/campaign" className="close">
            <Icon name="cross-sm"></Icon>
          </Link>
          <div className="p-2">
            <h1 className="pb-3 text-center text-gray-500 title">
              {" "}
              {campTitle}
            </h1>

            <div className="overflow-y-auto ">
              <h5 className="mt-3 mb-3 text-center text-green-900 ">
                {" "}
                Update Campaign
              </h5>
              <form onSubmit={handleSubmit} className="mt-4 row gy-4">
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Campaign Reference</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      required
                      type="text"
                      value={campId}
                      disabled
                    />
                  </FormGroup>
                </Col>

                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Wallet Number</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={walletId}
                      onChange={(e) => setWalletId(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Account Number</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campAccount}
                      onChange={(e) => setCampAccount(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="mb-1">Wallet Name</label>
                    <input
                      className="bg-gray-100 rounded-md form-control input-round"
                      value={campCustomer}
                      onChange={(e) => setCampCustomer(e.target.value)}
                      required
                      type="text"
                    />
                  </FormGroup>
                </Col>

                <button
                  className="text-white bg-green-800 rounded-md form-control hover:bg-green-500"
                  type="submit"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
